import React, { useEffect, useState } from 'react';
import { Instance } from '../../model/Instance';
import { ToastMessage, ToastMessageType } from '../../model/ToastMessage';
import { ToastContainer } from '../../components/ToastContainer';
import { Spinner } from '../../components/Spinner';
import { IServiceFactory } from '../../services/IServiceFactory';
import { InstanceNodes } from '../../components/InstanceNodes';

const Nodes = ({ serviceFactory}: Props) => {
  const [instances, setInstances] = useState<Instance[]>([]);
  const [instance, setInstance] = useState<Instance | undefined>(undefined);
  const [toastMessages, setToastMessages] = useState<ToastMessage[]>([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const instances = await serviceFactory.getInstanceService().all();
      setInstances(instances);
      if(instances.length > 0) {
        const currentInstance = instances.find(i => i.name === 'broox-studio-invoicing-lic') || instances[0];
        setInstance(currentInstance);
      }
    }
    catch(error) {
      setToastMessages([ { type: ToastMessageType.error, message: 'An error occurred while saving the instance', title: 'Error' } ]);
    }
    finally {
      setLoading(false);
    }
  }

  const onChangeInstance = (instanceId: string) => {
    const instance = instances.find(i => i.id === instanceId);
    setInstance(instance);
  }

  return (
    <>
      <h5 className="pb-3 mb-3 border-bottom">Billing</h5>
      <div className="row">
        <div className="col-3">
          <select data-testid="instance-select" className="form-select form-select-sm" value={instance?.id || ''} onChange={(event) => onChangeInstance(event.target.value)}>
            {
              instances.map(instance => 
                <option key={instance.id} value={instance.id}>{instance.name}</option>
              )
            }
          </select>
        </div>
      </div>
      <h5 className="pb-3 mb-3 border-bottom"></h5>
      {instance && <InstanceNodes instance={instance} />}
      <ToastContainer messages={toastMessages} />
      <Spinner loading={loading} />
    </>
  );
}

interface Props {
  serviceFactory: IServiceFactory
}

export { Nodes };
